import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./reportAbuse.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { WireI18n } from '~/modules/stores/i18nStore';
import { reviewStore } from '~/modules/stores/reviewStore';
import { sendNotification } from '~/modules/utilities/notificationUtilities';
class ReportAbuse extends LightningElement {
  constructor(...args) {
    super(...args);
    this.reviewId = void 0;
    this.closedFocusTarget = void 0;
    this.isReportingAbuse = void 0;
  }
  i18nCallback(i18n) {
    this.reportAbuseModalLabels = i18n.modals.reportAbuse;
    this.sharedLabels = i18n.shared;
  }
  async reportAbuse() {
    //the comment field is required so make sure it is populated
    if (!this.comment) {
      return;
    }
    const response = await reviewStore.reportAbuse(this.reviewId, this.comment);
    if (response.isSuccess) {
      const {
        successMessage
      } = response;
      // @ts-expect-error * Automated Type Error Fix
      sendNotification(successMessage, {
        previousFocusedElement: this.closedFocusTarget
      });
    } else {
      const {
        errorMessage,
        exceptionInfo
      } = response;
      // @ts-expect-error * Automated Type Error Fix
      sendNotification(errorMessage, {
        exceptionInfo,
        previousFocusedElement: this.closedFocusTarget
      });
    }
    this.close();
  }

  // @ts-expect-error * Automated Type Error Fix
  handleCommentChange(event) {
    this.comment = event.target.value || '';
  }
  close() {
    this.dispatchEvent(new CustomEvent('close'));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ReportAbuse, {
  publicProps: {
    reviewId: {
      config: 0
    },
    closedFocusTarget: {
      config: 0
    }
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    isReportingAbuse: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: reviewStore,
          selector: state => state.isReportingAbuse
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ReportAbuse, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;